import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import {AppSettingsService} from "@dabnet-kamu/libs/ui";


@Injectable({ providedIn: 'root' })
export class IdleService {

  constructor(
    private idle: Idle,
    private auth: AuthService,
    private router: Router,
    private appSettingService: AppSettingsService,
  ) {

    const timeouttime = appSettingService.idleTimeoutTime * 60
    // 1 saat = 3600 saniye
    idle.setIdle(timeouttime);
    idle.setTimeout(1); // timeout tetikleyici
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onTimeout.subscribe(() => {
      this.auth.logout(); // hem Angular hem IS4 logout
    });

    this.reset();
  }

  reset() {
    this.idle.watch();
  }
}
